import { useCallback, useMemo } from "react";

import { SiteControllerType } from "@/lib/gql/__generated__/graphql";

import type { SiteControllerSettingBaseFormModel } from "@/components/features/settings/site-controller/model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "@/components/features/settings/site-controller/model/base/use-case/use-create-model/methods";

import type { FormOptionType } from "@/components/ui/form/_types/type";

type Props = {
	hotelID: string;
	siteControllerType: SiteControllerSettingBaseFormModel["ViewModel"]["siteControllerType"]; //
	onSetSiteControllerType: SiteControllerSettingBaseFormModelMethodsType["siteControllerSettingBaseFormModelMethods"]["onSetSiteControllerType"];
};

export const useSiteControllerBaseSiteControllerType = ({
	siteControllerType,
	onSetSiteControllerType: _onSetSiteControllerType, //
}: Props) => {
	const siteControllerTypeOptions: FormOptionType[] = useMemo(() => {
		return [
			{
				id: "siteControllerTypeOptions_0",
				value: SiteControllerType.NotUsing,
				label: "CHILLNNで管理する",
			} satisfies FormOptionType,
			{
				id: "siteControllerTypeOptions_1",
				value: SiteControllerType.TlLincoln,
				label: "TL–リンカーン",
			},
			{
				id: "siteControllerTypeOptions_2",
				value: SiteControllerType.Neppan,
				label: "ねっぱん！",
			},
			{
				id: "siteControllerTypeOptions_3",
				value: SiteControllerType.Temairazu,
				label: "手間いらず",
			},
			{
				id: "siteControllerTypeOptions_4",
				value: SiteControllerType.Beds24,
				label: "Beds24",
			},
			{
				id: "siteControllerTypeOptions_5",
				value: SiteControllerType.AirHost,
				label: "AirHost（ベータ版）",
			},
		];
	}, []);

	const onSetSiteControllerType = useCallback(
		(value: string) => {
			_onSetSiteControllerType(value as SiteControllerType);
		},
		[_onSetSiteControllerType],
	);

	return {
		siteControllerTypeOptions,
		siteControllerType, //
		onSetSiteControllerType,
	};
};
